export default "__VITE_ASSET__d8021747__"